import { useState } from 'react';
import config from '../config';

interface FilterCriteria {
  ean: string;
}
const useToolDeleteById = () => {
  const [error, setError] = useState<string | null>(null);

  const toolDeleteById = async (id: number): Promise<number | null> => {
    try {
      const response = await fetch(`${config.centralApiBaseUrl}/api/tool/${id}`, {
        method: 'DELETE',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Deleting tool failed');
      }
      return id;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An unknown error occurred');
      return null;
    }
  };

  return { toolDeleteById, error };
};

export default useToolDeleteById;
